import { fetchProductDeliveryWeeks } from '../actions/routines';

const initialState = {
    data: new Map(),
    loading: false,
    error: null,
};

const productsDeliveries = (state = initialState, action) => {
    switch (action.type) {
        case fetchProductDeliveryWeeks.TRIGGER:
            return {
                ...state,
                loading: true,
            };
        case fetchProductDeliveryWeeks.SUCCESS:
            const newData = new Map(state.data);

            action.payload.forEach((deliveryData) => {
                newData.set(deliveryData.id, deliveryData);
            });
            return {
                ...state,
                data: newData,
                loading: false,
            };
        case fetchProductDeliveryWeeks.FAILURE:
            return {
                ...state,
                error: action.payload,
                loading: false,
            };
        case fetchProductDeliveryWeeks.FULFILL:
            return {
                ...state,
                loading: false,
            };
        default:
            return state;
    }
};

export default productsDeliveries;
